import { Link } from "react-router-dom";

export default function ProductGrid({ products }) {
    return (
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 place-items-center">

            {products.map((product) => (
                <div
                    key={product.id}
                    className="
                        w-[220px]
                        bg-white 
                        rounded-2xl 
                        shadow-md 
                        hover:shadow-xl 
                        transition 
                        overflow-hidden
                        mx-auto
                    "
                >
                    {/* IMAGE FIXED */}
                    <div className="h-60 flex items-center justify-center bg-white p-4">
                        <img
                            src={product.variants[0].image}
                            alt={product.name}
                            className="max-h-full w-auto object-contain mix-blend-multiply"
                        />
                    </div>



                    {/* CONTENT */}
                    <div className="px-4 pb-5 text-center">
                        <h3 className="text-base font-semibold text-[#7a0c18] leading-tight">
                            {product.name}
                        </h3>

                        <p className="mt-1 text-xs text-gray-600">
                            पैक साइज़: {product.variants.map(v => v.weight).join(", ")}
                        </p>

                        <Link
                            to={`/products/${product.id}`}
                            className="
                                inline-block 
                                mt-3 
                                px-4 py-1.5 
                                text-xs 
                                rounded-lg 
                                border 
                                border-[#7a0c18] 
                                text-[#7a0c18] 
                                hover:bg-[#7a0c18] 
                                hover:text-white 
                                transition
                            "
                        >
                            विवरण देखें
                        </Link>
                    </div>
                </div>
            ))}

        </div>
    );
}
